"use strict";
let hamburgerBtn = document.querySelector(".hamburger-btn"),
  sidebarMenuBox = document.querySelector(".header-sidebar");
hamburgerBtn.addEventListener("click", function () {
  sidebarMenuBox.classList.toggle("show");
});
const multiLevelMenus = document.querySelectorAll(".btn-open-sub-menu");
multiLevelMenus.forEach((e) => {
  e.addEventListener("click", function () {
    e.nextElementSibling.classList.add("show");
  });
});
const BackMultiLevelMenus = document.querySelectorAll(".btn-back-sub-menu");
BackMultiLevelMenus.forEach((e) => {
  e.addEventListener("click", function () {
    let t = e.closest(".sidebar-sub-menu-item");
    console.log(t), t.classList.contains("show") && t.classList.remove("show");
  });
});
const hamburgerCloseBtn = document.querySelectorAll(".hamburger-Close-btn");
hamburgerCloseBtn.forEach((e) => {
  e.addEventListener("click", function () {
    sidebarMenuBox.classList.toggle("show"),
      sidebarMenuBox.closest(".sidebar-sub-menu-item").forEach((e) => {
        e.nextElementSibling.classList.contains("show") &&
          e.nextElementSibling.classList.remove("show");
      });
  });
});
var r = document.querySelector(":root");
r.style.setProperty(
  "--header-top-height",
  document.querySelector(".header-top-bar")?.clientHeight + "px"
);
const quickViewButtons = document.querySelectorAll(".btn-quick-view");
function setImageDimension(e, t) {
  e.forEach(function (e) {
    let i = new URL(e.src);
    0 < e.offsetWidth &&
      0 < e.offsetHeight &&
      (i.searchParams.set("width", e.offsetWidth),
      i.searchParams.set("height", e.offsetHeight),
      t &&
        750 > window.screen.availWidth &&
        i.searchParams.set("crop", "center"),
      (e.src = i.toString()),
      e.setAttribute("height", e.offsetHeight),
      e.setAttribute("width", e.offsetWidth),
      e.removeAttribute("srcset"));
  });
}
quickViewButtons.forEach((e) => {
  e.addEventListener("click", async function (t) {
    document.documentElement.classList.add("t4s-lock-scroll");
    var i = e.parentNode;
    e.classList.add("is--loading"),
      await fetch(e.dataset.url)
        .then((e) => e.text())
        .then((t) => {
          t = new DOMParser()
            .parseFromString(t, "text/html")
            .querySelector(".modal.quickview-modal .modal__inner");
          let s = document.querySelector(".modal.quickview-modal");
          if (t) {
            (s.innerHTML = ""),
              (s.innerHTML = t.outerHTML),
              (s.style.display = "flex");
            var r = new Flickityt4s(
              ".quick-view-slider",
              document
                .querySelector(".quick-view-slider")
                .getAttribute("data-flickityt4s-js")
            );
            document
              .querySelector(".modal__inner .modal-close")
              .addEventListener("click", function (e) {
                (s.style.display = "none"),
                  document.documentElement.classList.remove("t4s-lock-scroll");
              }),
              jQuery_T4NT(".modal-quick-view-grid select[data-option]").on(
                "change",
                function () {
                  var e =
                      jQuery_T4NT(
                        ".modal-quick-view-grid [data-option='option-1']"
                      ).val() || !1,
                    t =
                      jQuery_T4NT(
                        ".modal-quick-view-grid [data-option='option-2']"
                      ).val() || !1,
                    i =
                      jQuery_T4NT(
                        ".modal-quick-view-grid [data-option='option-3']"
                      ).val() || !1,
                    s = jQuery_T4NT(".t4s-product__select[name='id']"),
                    a = "";
                  e && (a = `[option1="${e}"]`),
                    t && (a = `${a}[option2="${t}"]`),
                    i && (a = `${a}[option2="${i}"]`),
                    (e = s.find(`option${a}`)),
                    s.val(e.val()),
                    jQuery_T4NT(
                      ".modal-quick-view-grid [data-action-atc]"
                    ).attr("data-variant-id", `${s.val()}`),
                    (s = s
                      .find(
                        `option[option2="${jQuery_T4NT(
                          '[data-option-name="color"]'
                        ).val()}"]`
                      )
                      .attr("data-mdid")),
                    (s = jQuery_T4NT(`[data-image="${s}"]`).attr("data-index")),
                    r.select(s),
                    jQuery_T4NT(
                      ".modal-quick-view-grid .t4s-btn-atc_text"
                    ).text("Coming Soon!"),
                    jQuery_T4NT(
                      ".modal-quick-view-grid [data-action-atc]"
                    ).attr("disabled", "disabled"),
                    "false" != e.attr("data-available") &&
                      (jQuery_T4NT(
                        ".modal-quick-view-grid .t4s-btn-atc_text"
                      ).text("Add to cart"),
                      jQuery_T4NT(
                        ".modal-quick-view-grid  [data-action-atc]"
                      ).removeAttr("disabled", "disabled"));
                }
              );
          } else console.error("Section not found");
          e.classList.remove("is--loading"),
            (t =
              i
                .querySelector(".btn-wishlist [data-action-wishlist]")
                .classList.contains("is--added") || !1);
          var a =
            i
              .querySelector(".btn-compare [data-action-compare]")
              .classList.contains("is--added") || !1;
          (window.quickCompare = !1),
            t &&
              jQuery_T4NT(
                ".modal-quick-view-grid [data-action-wishlist]"
              ).click(),
            a &&
              jQuery_T4NT(
                ".modal-quick-view-grid [data-action-compare]"
              ).addClass("is--added t4s-tooltip-actived") &&
              jQuery_T4NT(
                ".modal-quick-view-grid [data-action-compare] .t4s-svg-pr-icon"
              ).html(
                '<svg class="t4s-svg-cp is-ic--added" viewBox="0 0 24 24"><use xlink:href="#t4s-icon-cp-added"></use></svg>'
              ),
            jQuery_T4NT(".modal-quick-view-grid [data-action-compare]").on(
              "click",
              function () {
                jQuery_T4NT(".modal.quickview-modal").hide();
              }
            );
        });
  });
}),
  window.addEventListener("load", function () {
    document.body.classList.contains("template-index") &&
      setImageDimension(document.querySelectorAll("img"), !0);
  });
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.header = document.querySelector(".section-header")),
      (this.headerIsAlwaysSticky =
        "always" === this.getAttribute("data-sticky-type") ||
        "reduce-logo-size" === this.getAttribute("data-sticky-type")),
      (this.headerBounds = {}),
      this.setHeaderHeight(),
      window
        .matchMedia("(max-width: 990px)")
        .addEventListener("change", this.setHeaderHeight.bind(this)),
      this.headerIsAlwaysSticky &&
        this.header.classList.add("shopify-section-header-sticky"),
      (this.currentScrollTop = 0),
      (this.preventReveal = !1),
      (this.onScrollHandler = this.onScroll.bind(this)),
      (this.hideHeaderOnScrollUp = () => (this.preventReveal = !0)),
      this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp),
      window.addEventListener("scroll", this.onScrollHandler, !1),
      this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty(
      "--header-height",
      `${this.header.offsetHeight}px`
    );
  }
  disconnectedCallback() {
    this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp),
      window.removeEventListener("scroll", this.onScrollHandler);
  }
  createObserver() {
    new IntersectionObserver((e, t) => {
      (this.headerBounds = e[0].intersectionRect), t.disconnect();
    }).observe(this.header);
  }
  onScroll() {
    let e = window.pageYOffset || document.documentElement.scrollTop;
    if (e > this.currentScrollTop && e > this.headerBounds.bottom) {
      if ((this.header.classList.add("scrolled-past-header"), this.preventHide))
        return;
      requestAnimationFrame(this.hide.bind(this));
    } else
      e < this.currentScrollTop && e > this.headerBounds.bottom
        ? (this.header.classList.add("scrolled-past-header"),
          this.preventReveal
            ? (window.clearTimeout(this.isScrolling),
              (this.isScrolling = setTimeout(() => {
                this.preventReveal = !1;
              }, 66)),
              requestAnimationFrame(this.hide.bind(this)))
            : requestAnimationFrame(this.reveal.bind(this)))
        : e <= this.headerBounds.top &&
          (this.header.classList.remove("scrolled-past-header"),
          requestAnimationFrame(this.reset.bind(this)));
    this.currentScrollTop = e;
  }
  hide() {
    this.headerIsAlwaysSticky ||
      (this.header.classList.add(
        "shopify-section-header-hidden",
        "shopify-section-header-sticky"
      ),
      this.closeMenuDisclosure());
  }
  reveal() {
    this.headerIsAlwaysSticky ||
      (this.header.classList.add("shopify-section-header-sticky", "animate"),
      this.header.classList.remove("shopify-section-header-hidden"));
  }
  reset() {
    this.headerIsAlwaysSticky ||
      this.header.classList.remove(
        "shopify-section-header-hidden",
        "shopify-section-header-sticky",
        "animate"
      );
  }
  closeMenuDisclosure() {
    (this.disclosures =
      this.disclosures || this.header.querySelectorAll("header-menu")),
      this.disclosures.forEach((e) => e.close());
  }
}

const searchInput = document.querySelector("#predictive-search-1"),
  searchLabel = document.querySelector(".search-label");
searchInput.addEventListener("focus", () => {
  searchLabel.classList.add("active");
}),
  searchInput.addEventListener("blur", () => {
    "" === searchInput.value.trim() && searchLabel.classList.remove("active");
  });

function applySearchBehavior() {
  let e = document.querySelector(".header-search-btn"),
    t = document.querySelector(".header-action-item-search"),
    i = document.querySelector(".header-menu-list"),
    s = document.querySelector("#predictive-search-1"),
    r = document.querySelector(".search-label");
  e.addEventListener("click", function () {
    "none" === t.style.display || "" === t.style.display
      ? ((t.style.display = "flex"), (i.style.display = "none"))
      : ((t.style.display = "none"), (i.style.display = "flex")),
      t.querySelector("input").focus();
  }),
    s.addEventListener("focus", () => {
      r.classList.add("active");
    }),
    s.addEventListener("blur", () => {
      "" === s.value.trim() && r.classList.remove("active");
    });
}
function removeSearchBehavior() {
  let e = document.querySelector(".header-action-item-search"),
    t = document.querySelector(".header-menu-list");
  e && t && ((e.style.display = ""), (t.style.display = ""));
  let i = document.querySelector(".header-search-btn"),
    s = document.querySelector("#predictive-search-1");
  i &&
    s &&
    (i.removeEventListener("click", applySearchBehavior),
    s.removeEventListener("focus", () => {}),
    s.removeEventListener("blur", () => {}));
}
function handleResize() {
  window.innerWidth > 1279 ? applySearchBehavior() : removeSearchBehavior();
}

customElements.define("sticky-header", StickyHeader),
  localStorage.getItem("t4s_cp") || localStorage.setItem("t4s_cp", ""),
  (window.onresize = function () {
    jQuery_T4NT(":root").css({
      "--header-height": jQuery_T4NT(".site-header").height() + "px",
    });
  }),
  document.documentElement.style.setProperty(
    "--header-height",
    document.querySelector(".site-header").clientHeight + "px"
  ),
  handleResize(),
  window.addEventListener("resize", handleResize);

const mediaQuery = window.matchMedia("(min-width: 1280px)");

mediaQuery.addEventListener("change", () => {
  // Remove all event listeners first
  document.querySelector(".header-search-btn").onclick = null;
  document.querySelector(".clear-search-btn").onclick = null;

  // Reassign event listeners only when media query matches
  mediaQuery.matches &&
    document
      .querySelector(".header-search-btn")
      .addEventListener("click", function () {
        let e = document.querySelector(".header-action-item-search"),
          t = document.querySelector(".header-menu-list");
        e.style.display = "flex";
        t.style.display = "none";
      });

  mediaQuery.matches &&
    document
      .querySelector(".clear-search-btn")
      .addEventListener("click", function () {
        let e = document.querySelector(".header-action-item-search"),
          t = document.querySelector(".header-menu-list");
        e.style.display = "none";
        t.style.display = "flex";
      });
});

mediaQuery.dispatchEvent(new Event("change"));

const tabletmediaQuery = window.matchMedia("(max-width: 1279px)");

tabletmediaQuery.addEventListener("change", () => {
  // Remove all event listeners first
  document.querySelector(".header-search-btn").onclick = null;
  document.querySelector(".clear-search-btn").onclick = null;

  // Reassign event listeners only when media query matches
  tabletmediaQuery.matches &&
    document
      .querySelector(".header-search-btn")
      .addEventListener("click", function () {
        let e = document.querySelector(".header-action-item-search");
        e.style.display = "flex";
      });

  tabletmediaQuery.matches &&
    document
      .querySelector(".clear-search-btn")
      .addEventListener("click", function () {
        let e = document.querySelector(".header-action-item-search");
        e.style.display = "none";
      });
});

tabletmediaQuery.dispatchEvent(new Event("change"));

$(document).ready(function () {
  $("body.search-result-page:not(.search-wishlist) .header-search-input")
    .next("label")
    .addClass("active");
});

$(document).ready(function () {
  function checkInputs() {
    let hasValue =
      $(".header-search-input").filter(function () {
        return $(this).val().trim() !== "";
      }).length > 0;

    $("body").toggleClass("fixed-body", hasValue);
  }

  $(".header-search-input").on("input", checkInputs);

  // Check on page load
  checkInputs();
});

$(document).on("click", function (event) {
  if (!$(event.target).closest(".unbxd-as-wrapper").length) {
    $("body").removeClass("fixed-body");
  }
});
